import React, {useState} from 'react'
import {
    Button, 
    Row,
    Col
 } from 'reactstrap';

function Index(props) {

    const [isOpen, setIsOpen] = useState(false);
    const openText = () => {
        setIsOpen(!isOpen);
    }
    const title = props.title;
    const text = props.text;
    const link = props.link;

    return (
        <div>
            {/*Card*/}
            <Row className='d-flex justify-content-center mb-1 mt-4'>
                <Col xs="12" className='d-flex justify-content-center'>
                    <b>{title}</b>
                </Col>
            </Row>
            <Row className='d-flex justify-content-center mt-1 mb-1'>
                <Col className='d-flex justify-content-center'>
                    <Button onClick={openText} color='primary'>Detail</Button>
                </Col>  
            </Row>
            {
                isOpen?
                    <div class="border border-secondary rounded mt-2 p-2">
                        <Row className='mt-1'>
                            <p style={{"textAlign":"justify", "textIndent":"25px"}}>
                                {text}
                            </p>
                        </Row>
                        <Row className='d-flex justify-content-center mb-1'>
                            <Col className='d-flex justify-content-center'>
                                <Button href={link} color='danger'>Show More</Button>
                            </Col>  
                        </Row>
                    </div>
                :
                    null
            }
        </div>
    )
}
export default Index;